import { PropsWithChildren } from 'react';
import { ITextProps } from './types';
import * as SC from './styles';
const Text: React.FC<PropsWithChildren<ITextProps>> = ({
  children,
  ...rest
}) => {
  return <SC.Text style={{ ...rest }}>{children}</SC.Text>;
};
export default Text;
